import React, { useState, useRef, useEffect } from 'react'
import styles from './style.module.scss'

const Timeline = ({ items, onChange }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const containerRef = useRef(null)
  const itemRefs = useRef([])

  // 处理滚动到中间的逻辑（垂直方向）
  useEffect(() => {
    const container = containerRef.current
    const item = itemRefs.current[currentIndex]

    if (container && item) {
      const containerHeight = container.clientHeight
      const itemHeight = item.offsetHeight
      const scrollPosition = item.offsetTop - containerHeight / 2 + itemHeight / 2

      container.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
      })
    }

    onChange?.(currentIndex)
  }, [currentIndex, onChange])

  // 计算透明度
  const getOpacity = index => {
    const distance = Math.abs(index - currentIndex)
    return Math.max(0, 1 - distance * 0.4)
  }

  return (
    <div>
      <div className={styles.container} ref={containerRef}>
        <div className={styles.track}>
          {items.map((item, index) => (
            <div
              key={item.date}
              ref={el => (itemRefs.current[index] = el)}
              className={`${styles.item} ${index === currentIndex ? styles.active : ''}`}
              onClick={() => setCurrentIndex(index)}
            >
              <span
                style={{
                  opacity: getOpacity(index),
                  // transform: `scale(${1 - Math.abs(index - currentIndex) * 0.1})`,
                }}
              >
                {item.date}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Timeline
